import httpClient from './httpClient';

export const BUNDLE_SET_ENDPOINT = '/backoffice/bundle-settings';

export const getBundleSetsAPI = (params = {}) => httpClient.get(BUNDLE_SET_ENDPOINT, { params });
export const getBundleSetAPI = (id) => httpClient.get(`${BUNDLE_SET_ENDPOINT}/${id}`);
export const postBundleSetAPI = (params) => httpClient.post(`${BUNDLE_SET_ENDPOINT}`, params);
export const updateBundleSetAPI = (id, params) => httpClient.put(`${BUNDLE_SET_ENDPOINT}/${id}`, params);
export const deleteBundleSetAPI = (id) => httpClient.delete(`${BUNDLE_SET_ENDPOINT}/${id}`);
